import {AxiosResponse} from "axios";
import Content from "../domain/Content";
import CrossCommContentAlert from "../domain/CrossCommContentAlert";
import CrossCommSession from "../domain/CrossCommSession";
import ContentPageRequest from "../domain/endpoint/ContentPageRequest";
import {RequestActionsConstant} from "../domain/endpoint/RequestActionsConstant";
import Poller from "../domain/poller/Poller";
import PollerPayload from "../domain/poller/PollerPayload";
import axios from "./axios";
import PollControllerBase from "./PollControllerBase";

export default class ContentController extends PollControllerBase {
    public static getContent(crossCommSession: CrossCommSession, teamsToken: string, action: RequestActionsConstant, requestPageNumber: number, searchText: string = "" ) {
        const request = new ContentPageRequest(crossCommSession, teamsToken, action, requestPageNumber, searchText);
        const payload = new PollerPayload((currentAttempt: number) => {
            return new Promise((resolve, reject) => {
                request.attempt = currentAttempt;
                axios.post("/content", request)
                    .then((data: AxiosResponse) => {
                        resolve(data.data);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        }, this.validator, 1000, 10, null);
        return (new Poller(payload)).execute();

    }

}
